import { API } from '../../../common/api'
import { crmServiceUrl } from '../../../common/utils/constants'
export const fetchPipelines = (crmId: string) =>
  API.get(`${crmServiceUrl}/crms/${crmId}/pipelines`)
export const updateCRMDetails = (crmId: string, data: unknown) =>
  API.patch(`${crmServiceUrl}/crms/${crmId}`, data)

export const fetchLabraReferralFields = () =>
  API.get(`${crmServiceUrl}/cloud-providers/aws/referral-default-value-fields`)
